import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import FormInputField from 'src/components/common/formInputField';
import { useForm } from 'react-hook-form';
import { useSettingActions } from 'src/store/settings/actions';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'src/store/reducers/state';
import ToastMessage from 'src/components/ToastContainer';
import { successMsg } from 'src/components/utilities/utils';
import { errorMsg } from 'src/components/utilities/utils';
import Loader from 'src/components/loader';
import CreditActivityCreditTypesModal from '../../creditActivityCreditTypesModal';
import SecureInputField from 'src/components/common/secureInputField';
const MembesIntegration: React.FC = () => {
  const dispatch = useDispatch();
  const settingAction = useSettingActions(dispatch);
  const {
    register,
    formState: { errors },
    handleSubmit,
    reset,
    control
  } = useForm();

  const { isIntegrationUpdated, membesIntegration, message, error, creditActivityCreditTypes, isCreditActivityCreditTypesLoading, isCreditActivityCreditTypesUpdated } = useSelector(
    (state: RootState) => {
      return {
        isIntegrationUpdated: state.setting.isIntegrationUpdated,
        membesIntegration: state.setting.membesIntegration,
        message: state.setting.message,
        error: state.setting.error,
        creditActivityCreditTypes: state.setting.creditActivityCreditTypes,
        isCreditActivityCreditTypesLoading: state.setting.isCreditActivityCreditTypesLoading,
        isCreditActivityCreditTypesUpdated: state.setting.isCreditActivityCreditTypesUpdated
      };
    }
  );

  const [showClientSecret, setShowClientSecret] = useState(false);

  useEffect(() => {
    if (membesIntegration) {
      const transformedData = {
        ...membesIntegration,
        dateFrom: membesIntegration.dateFrom ? membesIntegration.dateFrom.split('T')[0] : ''
      };
      reset(transformedData);
    }
  }, [membesIntegration]);

  useEffect(() => {
    settingAction.getMembesIntegrationRequest();
    settingAction.getCreditActivityCreditTypesRequest()
  }, []);

  useEffect(() => {
    if (isCreditActivityCreditTypesUpdated) {
      settingAction.getCreditActivityCreditTypesRequest()
    }
  }, [isCreditActivityCreditTypesUpdated])

  useEffect(() => {
    if (isIntegrationUpdated || isCreditActivityCreditTypesUpdated) {
      successMsg(message);
      settingAction.resetSettingStateRequest();
    }
  }, [isIntegrationUpdated, isCreditActivityCreditTypesUpdated]);

  const onSubmit = (data: any) => {
    if (membesIntegration == undefined || membesIntegration.id == undefined) {
      settingAction.addMembesIntegrationRequest(data);
    } else {
      const payloadData = {
        name: 'Membes',
        updateData: [
          { op: 'replace', path: 'clientId', value: data.clientId },
          { op: 'replace', path: 'clientSecret', value: data.clientSecret },
          { op: 'replace', path: 'orgId', value: data.orgId },
          { op: 'replace', path: 'apiV2AuthApiUrl', value: data.apiV2AuthApiUrl },
          { op: 'replace', path: 'apiV2BaseURL', value: data.apiV2BaseURL },
          { op: 'replace', path: 'apiV2ApiURl', value: data.apiV2ApiURl },
          { op: 'replace', path: 'profileApiUrl', value: data.profileApiUrl },
          { op: 'replace', path: 'eventapiUrl', value: data.eventapiUrl },
          { op: 'replace', path: 'dateFrom', value: data.dateFrom },
          { op: 'replace', path: 'useActiveFlagMember', value: data.useActiveFlagMember },
          { op: 'replace', path: 'writeBackCECredits', value: data.writeBackCECredits }
        ]
      };
      settingAction.updateIntegrationRequest(payloadData);
    }
  };

  useEffect(() => {
    if (error) {
      errorMsg('Error');
      settingAction.resetSettingStateRequest();
    }
  }, [error]);

  return (
    <div>
      <ToastMessage />
      <div className="mb-6">
        <h2 className="font-semibold my-1">Integration</h2>
        <ol className="breadcrumb">
          <li>
            <Link to="/">Home</Link>
          </li>
          <li>
            <Link to="/integrations">Integration</Link>
          </li>
          <li>
            <strong> Membes Integration</strong>
          </li>
        </ol>
        <Link to={`/integrations`}>
          <i className="fas fa-arrow-left mt-5"></i>
          <span className="ml-2">Go Back</span>
        </Link>
      </div>
      <form onSubmit={handleSubmit(onSubmit)} className="dashboard-card p-5 w-5/6">
        <div className="md:flex items-center mb-3 mt-3">
          <div className="md:w-4/12">
            <label className="font-semibold">Client Id</label>
          </div>
          <div className="md:w-8/12">
            <SecureInputField
              label={''}
              type={'text'}
              fieldName={'clientId'}
              control={control}
              errors={''}
              isRequired={false}
            />
          </div>
        </div>
        <div className="md:flex items-center mb-3 mt-3">
          <div className="md:w-4/12">
            <label className="font-semibold">Client Secret</label>
          </div>
          <div className="md:w-8/12 relative">
            <SecureInputField
              label={''}
              type={showClientSecret ? 'text' : 'password'}
              fieldName={'clientSecret'}
              control={control}
              errors={''}
              isRequired={false}
            />
            <i
              className={`fas ${showClientSecret ? 'fa-eye-slash' : 'fa-eye'
                } cursor-pointer absolute right-3 top-1/2 transform -translate-y-1/2`}
              onClick={() => setShowClientSecret(!showClientSecret)}></i>
          </div>
        </div>
        <div className="md:flex items-center mb-8 mt-6">
          <div className="md:w-4/12">
            <label className="font-semibold">OrgId</label>
          </div>
          <div className="md:w-8/12">
            <FormInputField
              label={''}
              type={'text'}
              fieldName={'orgId'}
              register={register}
              errors={''}
              isRequired={false}
            />
          </div>
        </div>
        <div className="md:flex items-center mb-8 mt-6">
          <div className="md:w-4/12">
            <label className="font-semibold">Auth Base URL</label>
          </div>
          <div className="md:w-8/12">
            <FormInputField
              label={''}
              type={'text'}
              fieldName={'apiV2BaseURL'}
              register={register}
              errors={''}
              isRequired={false}
            />
          </div>
        </div>
        <div className="md:flex items-center mb-8 mt-6">
          <div className="md:w-4/12">
            <label className="font-semibold">Token Path</label>
          </div>
          <div className="md:w-8/12">
            <FormInputField
              label={''}
              type={'text'}
              fieldName={'apiV2AuthApiUrl'}
              register={register}
              errors={''}
              isRequired={false}
            />
          </div>
        </div>
        <div className="md:flex items-center mb-8 mt-6">
          <div className="md:w-4/12">
            <label className="font-semibold">API URL</label>
          </div>
          <div className="md:w-8/12">
            <FormInputField
              label={''}
              type={'text'}
              fieldName={'apiV2ApiURl'}
              register={register}
              errors={''}
              isRequired={false}
            />
          </div>
        </div>
        <div className="md:flex items-center mb-3 mt-3">
          <div className="md:w-4/12">
            <label className="font-semibold">User Profile Api Url</label>
          </div>
          <div className="md:w-8/12">
            <FormInputField
              label={''}
              type={'text'}
              fieldName={'profileApiUrl'}
              register={register}
              errors={''}
              isRequired={false}
            />
          </div>
        </div>
        <div className="md:flex items-center mb-3 mt-3">
          <div className="md:w-4/12">
            <label className="font-semibold">Event Api Url</label>
          </div>
          <div className="md:w-8/12">
            <FormInputField
              label={''}
              type={'text'}
              fieldName={'eventapiUrl'}
              register={register}
              errors={''}
              isRequired={false}
            />
          </div>
        </div>
        <div className="md:flex items-center mb-8 mt-6">
          <div className="md:w-4/12">
            <label className="font-semibold">Use Active flag as Member</label>
          </div>
          <div className="md:w-8/12">
            <div className="flex items-center">
              <div className="form-check form-switch pl-0 flex-items mb-2">
                <div className="relative">
                  <input
                    className="form-check-input switch-btn"
                    type="checkbox"
                    id="useActiveFlagMember"
                    {...register('useActiveFlagMember')}
                  />
                  <i className="fas fa-check checkbox-tick hidden"></i>
                  <i className="fas fa-times checkbox-cross"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="md:flex items-center mb-8 mt-6">
          <div className="md:w-4/12">
            <label className="font-semibold">Write Back CE Credits</label>
          </div>
          <div className="md:w-8/12">
            <div className="flex items-center">
              <div className="form-check form-switch pl-0 flex-items mb-2">
                <div className="relative">
                  <input
                    className="form-check-input switch-btn"
                    type="checkbox"
                    id="writeBackCECredits"
                    {...register('writeBackCECredits')}
                  />
                  <i className="fas fa-check checkbox-tick hidden"></i>
                  <i className="fas fa-times checkbox-cross"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="md:flex items-center mb-8 mt-6">
          <div className="md:w-4/12">
            <label className="font-semibold">Send Credits From Date</label>
          </div>
          <div className="md:w-8/12">
            <FormInputField
              label={''}
              type={'date'}
              fieldName={'dateFrom'}
              register={register}
              errors={''}
              isRequired={false}
            />
          </div>
        </div>
        <div className="flex items-center p-5 mt-2">
          <button type="submit" className="px-6 btn-primary w-28 mr-0 ml-3 mt-0">
            Save
          </button>
        </div>
      </form>

      <div className="dashboard-card p-5 w-5/6 mt-5">
        <div className="flex">
          <h3 className="font-bold text-lg">CE Credit Type Mapping</h3>
          <button
            type="button"
            data-bs-toggle="modal"
            data-bs-target="#creditActivityCreditTypesModal"
            className="btn-primary w-auto mt-0 mr-0 ml-auto mb-4 borderonly-btn">
            Add
          </button>
        </div>

        <div className="">
          <table className="table-auto w-full border">
            <thead className="text-xs font-semibold uppercase bg-gray-100">
              <tr>
                <th className="p-2">
                  <div className="font-semibold text-left">Credit Type</div>
                </th>
                <th className="p-2">
                  <div className="font-semibold text-left">Name Mapping</div>
                </th>
                <th className="p-2">
                  <div className="text-left invisible">Action</div>
                </th>
              </tr>
            </thead>
            <tbody className="text-sm divide-y divide-gray-100">
              {isCreditActivityCreditTypesLoading && (
                <tr>
                  <td>
                    <Loader />
                  </td>
                </tr>
              )}
              <>
                {creditActivityCreditTypes &&
                  creditActivityCreditTypes.map((item) => {
                    return (
                      <tr key={item.id}>
                        <td className="p-2">{item.type}</td>
                        <td className="py-2">{item.mappingtext || <span className="text-gray-400 italic">Not mapped</span>}</td>
                        {/* <td className="p-2">
                          <div className="dropdown relative">
                            <a
                              className="
                                          dropdown-toggle
                                          transition
                                          duration-150
                                          ease-in-out border h-8 w-8 flex items-center justify-center rounded-md"
                              href="#"
                              type="button"
                              id="ActionButton"
                              data-bs-toggle="dropdown"
                              aria-expanded="false">
                              <i className="fas fa-ellipsis-v"></i>
                            </a>
                            <ul
                              className="dropdown-menu action-dropdown"
                              aria-labelledby="ActionButton">
                              <li
                                data-bs-toggle="modal"
                                data-bs-target="#creditActivityCreditTypesModal">
                                <span className="dropdown-item flex-items cursor-pointer">
                                  <i className="fas fa-edit w-6"></i>
                                  <span>Edit</span>
                                </span>
                              </li>

                            </ul>
                          </div>
                        </td> */}
                      </tr>
                    );
                  })}
              </>
            </tbody>
          </table>
        </div>
      </div>
      <CreditActivityCreditTypesModal />
    </div>
  );
};

export default MembesIntegration;
